import styled, { StyledProp } from '@/styled';

import CourseExpired from './Expired';
import CourseNotRelesed from './NotReleased';
import BlockedBySomenone from '../Base/BlockedBySomeone';
import NotAuthenticated from '../Base/NotAuthenticated';
import NotPurchased from '../Base/NotPurchased';

const CourseAlerts = (props: StyledProp) => {
  return (
    <>
      <CourseExpired className={props.className} />
      <CourseNotRelesed className={props.className} />
      <NotAuthenticated className={props.className} />
      <BlockedBySomenone className={props.className} />
      <NotPurchased className={props.className} />
    </>
  );
};

export default styled(CourseAlerts)`
  margin-bottom: ${({ theme }) => theme.space.pxToRem(8)};
`;
